<template>
  <button :class="classesTabIcon" :disabled="disabled" type="button">
    <IconBase :icon="icon" />
  </button>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import style from "./TabIcon.module.scss";
import IconBase from "@/elements/UI/icon/IconBase.vue";

export default defineComponent({
  name: "TabIcon",
  components: {IconBase},
  props: {
    icon: {
      type: String,
      default: ""
    },
    size: {
      type: String as PropType<ButtonIconSizes>,
      default: "24"
    },
    variant: {
      type: String as PropType<ButtonIconColor>,
      default: "subtle"
    },
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      style
    };
  },
  computed: {
    classesTabIcon() {
      return [
        this.style.tabIcon,
        this.style[`size${this.size}`],
        this.style[this.variant],
        this.active ? this.style.active : ""
      ];
    }
  }
});
</script>
